<template>
  <div class=" is-fullwidth">
    <section class="main-content columns is-fullheight">
        <div class="column is-2 sidebar-container"  v-if="sidebarVisible==true">
                <div class="  is-fullheight sticky-sidebar" >
     <aside class="menu column  aside   is-fullheight" >
        <form action="">
<h3 class="title is-size-5">Location Filters</h3>

<div class="field ">
                          <div class="control">
                            <select class="select input is-small" @change="getOrders()" v-model="location_type">
    <option value="makeup_location">Makeup Location Equals</option>
    <option value="cutting_location">Cutting Location Equals</option>
    <option value="print_location">Print Location Equals</option>
    <option value="print_or_cutting_location">Print Or Cutting Location Equals</option>
</select>
                             
                          </div>
                      </div>

<div class="field mb-5">
                          <div class="control">
                            <select class="select input is-small" @change="getOrders()" v-model="location_id">
    <option value="">All Locations</option>
    <option :value="row.id" v-for="row in locations" :key="row.id">{{ row.name}}</option>
    
</select>
                             
                          </div>
                      </div>


<h3 class="title is-size-5">Order Filters</h3>
<div class="buttons">
<button type="button" class="button is-fullwidth is-small" :disabled="loading==true" :class="{'is-success' : includes_embroidery == 1}" @click="toggleIncludesEmbroideryButton()">Embroidery Orders</button>
<button type="button" class="button is-fullwidth is-small" :disabled="loading==true" :class="{'is-success' : includes_silicon== 1}" @click="toggleIncludesSiliconButton()">Silicon Orders</button>
<button type="button" class="button is-fullwidth is-small" :disabled="loading==true" :class="{'is-success' : includes_knitted_trims== 1}" @click="toggleIncludesKnittedTrimsButton()">Knitted Trims</button>
</div>
</form>
     </aside>
     </div>
			 </div>

  
      <div class=" column is-10" :class="{'is-12':sidebarVisible==false}">
        
        <div class="section">
          <button @click="exportXLS()" class="button is-info is-pulled-right" v-if="this.show_list == true">Export to Excel</button>
            <div class="buttons ">
              <div class="button is-light mr-4" @click="sidebarVisible = !sidebarVisible">Toggle Menu</div>
              <div class="button " :class="{'is-success' : this.show_summary == true}" :disabled="loading==true" @click="toggleButtons('summary')">Summary</div>
              <div class="button " :class="{'is-success' : this.show_list == true}" :disabled="loading==true" @click="toggleButtons('list')">List</div>

              
            </div>
           
            <div class="notification is-info" v-if="loading == true">Loading orders ...</div>

            <table class="table is-hoverable is-fullwidth is-size-7 is-striped" id="orderstable" v-if="loading==false && filteredOrders.length > 0 && this.show_list==true">
                    <thead>
                        <tr>
                        <th width="60">&nbsp;</th>
                    <th>PO Number</th>
                        <th>Customer</th>
                    <th>Garment</th>
                    <th>Type</th>
                    <th>Design Name</th>
                    <th width="80">Extras</th>
                    <template v-if="includes_knitted_trims == 1">
                      <th>Trim Completed</th>
                      <th>Trim Type</th>
                      <th>Trim Despatched</th>
                      <th>Despatch Method</th>
                    </template>
                    
                    <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
                        <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
                        <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
                    </th>
                    <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
                        <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
                        <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
                    </th>
                    
                    <th>Qty</th>
                    <th>Print</th>
                    <th>Cutting</th>
                    <th>Makeup</th>
                </tr>
                    </thead>
                    <tbody>
                       
                        <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
                    <td >
                            <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
                        </td>
                        <td >{{order.ponumber}}</td>
                    <td>{{order.clientname}}</td>
                    <td>{{order.garmentname}}</td>
                    <td>
                      <span v-if="order.fully_printed==1">F/P</span>
                      <span v-if="order.part_printed==1">P/P</span>
                      <span v-if="order.cut_sew==1">C/S</span>
                    </td>
                    <td>{{ order.designname}}</td>
                    <td><OrderExtras :order="order"/></td>
                    <template v-if="includes_knitted_trims == 1">
                      <td><span v-if="order.knit_complete == 1">{{ convertToUKDate(order.knit_complete_date) }}</span></td>
                      <td><span v-if="order.knit_complete == 1">{{ order.knit_complete_type}}</span></td>
                      <td><span v-if="order.knit_despatched == 1">{{ convertToUKDate(order.knit_despatched_date) }}</span></td>
                      <td><span v-if="order.knit_despatched == 1">{{ order.knit_despatched_location}} - {{ order.knit_despatched_method}}</span></td>
                    </template>
                    <td>{{order.orderdate}}</td>
                    <td>{{order.deliverydate}}</td>
                    
                    <td>{{ order.total_qty }}</td>
                    <td>{{ order.print_location_name }}</td>
                    <td>{{ order.cutting_location_name }}</td>
                    <td>{{ order.makeup_location_name }}</td>
                        
                        </tr>
                    </tbody>
                </table>

           
                  <div v-if="show_summary == true && loading == false && working == false">
                    <h3 class="title">Overview Of Offshore Orders Not Completed Yet</h3>
                    <div class="columns">
                      <div class="column">
                        <article class="message is-success">
                          <div class="message-header">
                            <p>Total</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.totalOrders }} orders<br />
                             {{ orderStats.totalQty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Fully Printed</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.fullyPrinted.count }} orders<br />
                            {{ orderStats.fullyPrinted.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Part Printed</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.partPrinted.count }} orders<br />
                            {{ orderStats.partPrinted.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Cut & Sew</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.cutSew.count }} orders<br />
                            {{ orderStats.cutSew.qty }} garments
                          </div>
                        </article>
                        </div>

                    </div>
                  
                 
                    <h3 class="title">Status of Sublimated Orders (Fully Printed and Part Printed)</h3>
                    <div class="columns">
                      <div class="column">
                        <article class="message is-success">
                          <div class="message-header">
                            <p>Awaiting Artwork</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.requiresArtwork.count }} orders<br />
                            {{ orderStats.requiresArtwork.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Awaiting Sub. Print</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.awaitingPrint.count }} orders<br />
                            {{ orderStats.awaitingPrint.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Awaiting Transmatic</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.awaitingTrans.count }} orders<br />
                            {{ orderStats.awaitingTrans.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Awaiting Cutting</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.awaitingDigitalCutting.count }} orders<br />
                            {{ orderStats.awaitingDigitalCutting.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Cutting Complete</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.digitalCuttingComplete.count }} orders<br />
                            {{ orderStats.digitalCuttingComplete.qty }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-warning">
                          <div class="message-header">
                            <p>Ready For Makeup</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.readyForMakeup.count }} orders<br />
                            {{ orderStats.readyForMakeup.qty }} garments
                          </div>
                        </article>
                        </div>

                        
                    </div>

                    <h3 class="title">Status of Cut/Sew Orders</h3>
                    <div class="columns">
                      <div class="column">
                        <article class="message is-success">
                          <div class="message-header">
                            <p>Awaiting Cutting</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{ orderStats.awaitingCutSewCutting.count }} orders<br />
                            {{ orderStats.awaitingCutSewCutting.qty }} garments
                          </div>
                        </article>
                        </div>

                       

                        

                        
                    </div>

                    <h3 class="title">Makeup</h3>
                    <div class="columns">
                      <div class="column">
                        <article class="message is-success">
                          <div class="message-header">
                            <p>Waiting to Scan on Factory Floor</p>
                           
                          </div>
                          <div class="message-body">
                            
                            {{  orderStats.inMakeup.qty - orderStats.onFloor }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Currently On Factory Floor</p>
                           
                          </div>
                          <div class="message-body">
                            
                            
                            {{  orderStats.onFloor - orderStats.offFloor }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                        <article class="message is-link">
                          <div class="message-header">
                            <p>Off Floor</p>
                           
                          </div>
                          <div class="message-body">
                            
                      
                            {{ orderStats.offFloor }} garments
                          </div>
                        </article>
                        </div>

                        <div class="column">
                         
                        </div>
                    </div><!-- end of row-->
                  
                  </div>
        </div>

        <!-- For exporting to Excel-->
        <table class="" id="orderstable-excel" style="display:none">
                    <thead>
                        <tr>
                        
                    <th>PO Number</th>
                        <th>Customer</th>
                    <th>Garment</th>
                    <th>Design Name</th>
                    <th >Extras</th>
                    <template v-if="includes_knitted_trims == 1">
                      <th>Trim Completed</th>
                      <th>Trim Type</th>
                      <th>Trim Despatched</th>
                      <th>Despatch Method</th>
                    </template>
                    
                    <th >Ordered
                        
                    </th>
                    <th>Delivery
                       
                    </th>
                    
                    <th>Qty</th>
                    <th>Print</th>
                    <th>Cutting</th>
                    <th>Makeup</th>
                </tr>
                    </thead>
                    <tbody>
                       
                        <tr v-for="order in filteredOrders" v-bind:key="'export' + order.orderID">
                    
                        <td >{{order.ponumber}}</td>
                    <td>{{order.clientname}}</td>
                    <td>{{order.garmentname}}</td>
                    <td>{{order.designname}}</td>
                    <td><OrderExtras :order="order"/></td>
                    <template v-if="includes_knitted_trims == 1">
                      <td><span v-if="order.knit_complete == 1">{{ order.knit_complete_date }}</span></td>
                      <td><span v-if="order.knit_complete == 1">{{ order.knit_complete_type}}</span></td>
                      <td><span v-if="order.knit_despatched == 1">{{ order.knit_despatched_date }}</span></td>
                      <td><span v-if="order.knit_despatched == 1">{{ order.knit_despatched_location}} - {{ order.knit_despatched_method}}</span></td>
                    </template>
                    <td>{{order.orderdate_raw}}</td>
                    <td>{{order.deliverydate_raw}}</td>
                    
                    <td>{{ order.total_qty }}</td>
                    <td>{{ order.print_location_name }}</td>
                    <td>{{ order.cutting_location_name }}</td>
                    <td>{{ order.makeup_location_name }}</td>
                        
                        </tr>
                    </tbody>
                </table>
      </div>
		</section>
    
    
    
    
  </div>
</template>

<script>
import XLSX from 'xlsx';
//import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";
import OrderExtras from '@/components/OrderExtras.vue';

export default {
    components: {
    OrderExtras
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      locations: [],
      order_by: 'deliverydate ASC',
      
      showAddButtons: true,
      accessToken: '',
      includes_embroidery: 0,
      includes_silicon: 0,
      includes_knitted_trims: 1,
      location_type: 'makeup_location',
      location_id: '',
      show_summary: false,
      show_list: true,
      sidebarVisible: true
    }
  },
   methods: {
    exportXLS() {
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable-excel'), {sheet:"All Orders"});
		 XLSX.writeFile(wb, 'Offshore Order Export.xlsx')

	 },
    toggleButtons(button)
    {
        if(button == "summary")
        {
          if(this.show_summary == true)
          {
            this.show_summary = false
            this.show_list = true
          }
          else {
            this.show_summary = true
            this.show_list = false
          }
        }

        if(button == "list")
        {
          if(this.show_list == true)
          {
            this.show_summary = true
            this.show_list = false
          }
          else {
            this.show_summary = false
            this.show_list = true
          }
        }

        this.getOrders();
    },
    toggleIncludesEmbroideryButton() {
        if(this.includes_embroidery == 1)
        {
            this.includes_embroidery = 0
        }
        else{
            this.includes_embroidery = 1
        }
        this.getOrders();
    },
    toggleIncludesSiliconButton() {
        if(this.includes_silicon == 1)
        {
            this.includes_silicon = 0
        }
        else{
            this.includes_silicon = 1
        }
        this.getOrders();
    },
    toggleIncludesKnittedTrimsButton() {
        if(this.includes_knitted_trims == 1)
        {
            this.includes_knitted_trims = 0
        }
        else{
            this.includes_knitted_trims = 1
        }
        this.getOrders();
    },
      async getOrders() {
        this.loading=true
        this.orders = []

        var show_makeup_logs = 0
        if(this.show_summary == true)
      {
        show_makeup_logs = 1
      }
        
        var querystring = "orders?location=offshore&with_makeup_logs=" + show_makeup_logs + "&includes_embroidery=" + this.includes_embroidery + "&with_knitted_trims=1&knitted_trim=" + this.includes_knitted_trims + "&includes_silicon=" + this.includes_silicon + "&completed=0&limit=&with_quantities=1&exclude_socks=1&delivery_start_date=2024-01-01&order_by=" + this.order_by
        
        if(this.location_type == "makeup_location")
        {
            querystring = querystring + "&makeup_location_id=" + this.location_id 
        }else if(this.location_type == "cutting_location")
        {
            querystring = querystring + "&cutting_location_id=" + this.location_id 
        }else if(this.location_type == "print_location")
        {
            querystring = querystring + "&print_location_id=" + this.location_id 
        }else if(this.location_type == "print_or_cutting_location")
        {
            querystring = querystring + "&print_or_cutting_location_id=" + this.location_id 
        }
        

        UtilityService.getSimpleApiData(this.accessToken, querystring).then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      

        
      },
      async getLocations() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?offshore=1&makeup=1").then(
               response => this.locations = response 
            );
      },
      
    
   
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders

          return filteredOrders
       
     },
    
  orderStats() {
    const stats = {
      totalOrders: 0,
      totalQty: 0,
      fullyPrinted: { count: 0, qty: 0 },
      partPrinted: { count: 0, qty: 0 },
      cutSew: { count: 0, qty: 0 },
      requiresArtwork: { count: 0, qty: 0 },
      awaitingPrint: { count: 0, qty: 0 },
      awaitingTrans: { count: 0, qty: 0 },
      awaitingDigitalCutting : { count: 0, qty: 0 },
      digitalCuttingComplete: { count: 0, qty: 0 },
      awaitingCutSewCutting: { count: 0, qty: 0 },
      readyForMakeup: { count: 0, qty: 0 },
      inMakeup: { count: 0, qty: 0 },
      onFloor: 0,
      offFloor: 0
    };

    for (const order of this.orders) {
      const qty = order.total_qty || 0;
      stats.totalOrders += 1;
      stats.totalQty += qty;

      if (order.fully_printed === 1) {
        stats.fullyPrinted.count += 1;
        stats.fullyPrinted.qty += qty;
      }

      if (order.part_printed === 1) {
        stats.partPrinted.count += 1;
        stats.partPrinted.qty += qty;
      }

      if (order.cut_sew === 1) {
        stats.cutSew.count += 1;
        stats.cutSew.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.artwork_completed === 0) {
        stats.requiresArtwork.count += 1;
        stats.requiresArtwork.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.artwork_completed === 1 && order.artwork_printed_paper === 0) {
        stats.awaitingPrint.count += 1;
        stats.awaitingPrint.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.artwork_printed_paper === 1 && order.artwork_printed_rolls === 0) {
        stats.awaitingTrans.count += 1;
        stats.awaitingTrans.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.artwork_printed_rolls === 1 && order.digital_print_cutting === 0) {
        stats.awaitingDigitalCutting.count += 1;
        stats.awaitingDigitalCutting.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.artwork_printed_rolls === 1 && order.digital_print_cutting === 1 && order.ready_for_makeup == 0) {
        stats.digitalCuttingComplete.count += 1;
        stats.digitalCuttingComplete.qty += qty;
      }

      if ((order.fully_printed ==1 || order.part_printed == 1) && order.ready_for_makeup == 1) {
        stats.readyForMakeup.count += 1;
        stats.readyForMakeup.qty += qty;
      }

      // Cut Sew orders
      if ((order.cut_sew ==1 || order.part_printed ==1)  && order.cutsew_cutting === 0) {
        stats.awaitingCutSewCutting.count += 1;
        stats.awaitingCutSewCutting.qty += qty;
      }

      if (order.ready_for_makeup === 1) {
        stats.inMakeup.count += 1;
        stats.inMakeup.qty += qty;

        // Sum on_floor_completed_qty only where ready_for_makeup is 1
        stats.onFloor += order.on_floor_completed_qty || 0;
        stats.offFloor += order.off_floor_completed_qty || 0;
      }
    }

    return stats;
  }
},


  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getLocations();
        });
  },
 
  mounted() {
    /*if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }*/
      
  },
  watch: {
   /* makeup_location_id: function () {
      localStorage.production_allocated_makeup_location_id = this.makeup_location_id
      if(this.accessToken != "")
      {
        this.getOrders()
      }
    },*/
  }
}


</script>

